import { Component, EventEmitter, Input, OnChanges, Output, OnInit, SimpleChanges } from '@angular/core';
import { ValidationError } from '../../models/validation/validation-error';
import { ValidationErrors } from '../../models/validation/validation-errors';
import { ReferenceDataService } from '../../services/reference-data.service';

@Component({
  selector: 'boi-validation-error-generic',
  templateUrl: './validation-error-generic.component.html',
  styleUrls: ['./validation-error-generic.component.scss']
})
export class ValidationErrorGenericComponent implements OnChanges, OnInit {
  @Input() public propertyNames: Array<string>;
  @Input() public validationErrors: ValidationErrors;

  @Output() readonly errorChange = new EventEmitter<boolean>();

  constructor(private readonly referenceDataService: ReferenceDataService) {}

  ngOnInit(): void {
    this.errorChange.emit(false);
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.validationErrors && simpleChanges.validationErrors.currentValue) {
      if (this.validationErrors && this.validationErrors.BusinessValidationErrors) {
        let validationError: ValidationError;
        let hasError = false;

        this.propertyNames.forEach((propName) => {
          validationError = this.validationErrors.BusinessValidationErrors.find((error) => error.key === propName);

          if (validationError && !hasError) {
            hasError = true;
          }
        });

        this.errorChange.emit(hasError);
      }
    }
  }

  public localizeErrorMessage(validationErrorName: string): string {
    if (this.validationErrors && this.validationErrors.BusinessValidationErrors) {
      const validationError = this.validationErrors.BusinessValidationErrors.find(
        (error) => error.key === validationErrorName
      );

      if (validationError) {
        return this.referenceDataService.getLocalizeErrorMessage(validationError);
      }
    }

    return undefined;
  }
}
